import importAll from "./importAll";

const allAircraft = importAll(require.context("assets/images/aircraft/passenger", true, /\.png$/));

function getAircraftImage(path) {
	return allAircraft[path];
}

export default getAircraftImage;
